import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Api, { FetchParams } from '../utils/Api';

export const fetchAllergenDietaryTags = createAsyncThunk(
  '$fetchAllergenOptions',
  async (data: undefined, { rejectWithValue }) => {
    try {
      const fetchParams: FetchParams = {
        path: '/api/v1/public/tags',
        method: 'GET',
      };
      const response = await Api.fetch(fetchParams);
      return response.data;
    } catch (e) {
      console.error('Fetch allergen options failed', { e });
      rejectWithValue(e);
    }
  },
);

const tagsAllergenDietarySlice = createSlice({
  name: '$tagsAllergenDietary',
  initialState: null,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchAllergenDietaryTags.fulfilled, (state, action) => {
      return action.payload;
    });
  },
});
export default tagsAllergenDietarySlice.reducer;
